// extracted by mini-css-extract-plugin
export default {"l":"_0a7525995b"};